import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api-client';
import type { BookingPushLog, PaginatedResponse } from '@/types/api';

export const bookingPushKeys = {
  all: ['booking-push'] as const,
  logs: (params?: BookingPushLogsParams) => [...bookingPushKeys.all, 'logs', params] as const,
};

interface BookingPushLogsParams {
  partnerAccountId?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export function useBookingPushLogs(params: BookingPushLogsParams = {}) {
  const searchParams = new URLSearchParams();

  if (params.partnerAccountId) {
    searchParams.set('partnerAccountId', params.partnerAccountId);
  }
  if (params.status) {
    searchParams.set('status', params.status);
  }
  if (params.page) {
    searchParams.set('page', params.page.toString());
  }
  if (params.limit) {
    searchParams.set('limit', params.limit.toString());
  }

  const queryString = searchParams.toString();
  const url = `/api/v1/webhooks/booking-push-logs${queryString ? `?${queryString}` : ''}`;

  return useQuery({
    queryKey: bookingPushKeys.logs(params),
    queryFn: () => api.get<PaginatedResponse<BookingPushLog>>(url),
  });
}
